import script from "./VoiceTranscribeMessageButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./VoiceTranscribeMessageButton.vue?vue&type=script&lang=ts&setup=true"

import "./VoiceTranscribeMessageButton.vue?vue&type=style&index=0&id=520b005a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-520b005a"]])

export default __exports__